import React, { useState, useEffect, useRef } from "react";
import { id, parseUnits } from "ethers/lib/utils";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import logo from "../../../assets/images/logo.png";
import "./Navbar.css";
import "@quadrata/core-react/lib/cjs/quadrata-ui.min.css";
import { ethers } from "ethers";
import { useWalletClient, useAccount } from "wagmi";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import axios from "axios";

export const Navbar: React.FC<{ accessToken: string }> = ({
  accessToken,
  contract,
}) => {
  const [isOwner, setIsOwner] = useState(false);
  const [showNavbar, setShowNavbar] = useState(false);
  const [apiAccessToken, setApiAccessToken] = useState("");
  const [isIEOActive, setIsIEOActive] = useState(false);

  const chainId = 80001;
  const { address: account, isConnecting, isDisconnected } = useAccount();
  const { data: signer } = useWalletClient();

  // console.log(isIEOActive);
  const totalTokens = useRef("");

  useEffect(() => {
    const checkOwner = () => {
      // 0x83aB680a4BEc9b8be243FDf790D920DEbFb968FD
      if (account === "0x83aB680a4BEc9b8be243FDf790D920DEbFb968FD") {
        setIsOwner(true);
      }
      if (account !== "0x83aB680a4BEc9b8be243FDf790D920DEbFb968FD") {
        setIsOwner(false);
      }
    };
    checkOwner();
    // console.log(contract);
  }, [account]);

  const stopPreIeo = async () => {
    if (await contract.stopPreIEO()) {
      alert("IEO is stopped");
    }
  };

  const handleExportWebhookCsv = async () => {
    try {
      const response = await axios.get(
        "https://loop-of-infinity.onrender.com/export-webhook-csv",
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "webhook_data.csv";
      // console.log(link);
      link.click();
    } catch (error) {
      console.error("Error exporting webhook CSV:", error);
    }
  };

  const handleExportMetaPaymentCsv = async () => {
    try {
      const response = await axios.get(
        "https://loop-of-infinity.onrender.com/export-metapayment-csv",
        {
          responseType: "blob", // Set response type to blob for downloading files
        }
      );
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "metapayment_data.csv";
      // console.log(link);

      link.click();
    } catch (error) {
      console.error("Error exporting metaPayment CSV:", error);
    }
  };

  const handleExportMergedCsv = async () => {
    try {
      const response = await axios.get(
        "https://loop-of-infinity.onrender.com/export-merged-csv",
        {
          responseType: "blob", // Set response type to blob for downloading files
        }
      );
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "merged_data.csv";
      // console.log(link);

      link.click();
    } catch (error) {
      console.error("Error exporting merged CSV:", error);
    }
  };

  return (
    <>
      <nav className="TokeenSale-navbar">
        <a href="/">
          <div className="logo">
            <img src={logo} alt="Logo" />
          </div>
        </a>
        <div
          onClick={() => {
            setShowNavbar(true);
          }}
          className={!showNavbar ? "toggle-open" : "hide"}
        >
          <GiHamburgerMenu size={24} />
        </div>
        <div
          className={
            showNavbar ? "tokensale-nav-right active" : "tokensale-nav-right"
          }
        >
          <div
            className="toggle-close"
            onClick={() => {
              setShowNavbar(false);
            }}
          >
            <AiOutlineClose color="white" size={24} />
          </div>

          {isOwner ? (
            <div className="owner-btns">
              <button
                onClick={() => {
                  handleExportWebhookCsv();
                }}
              >
                Webhook
              </button>
              <button
                onClick={() => {
                  console.log("user clicked");

                  handleExportMetaPaymentCsv();
                }}
              >
                User
              </button>
              <button
                onClick={() => {
                  console.log("merged clicked");
                  handleExportMergedCsv();
                }}
              >
                Merged
              </button>
              <button
                className="withdraw-matic"
                onClick={async () => {
                  await contract.withdrawUnsoldLOITokens();
                  alert("Tokens Withdrawn");
                }}
              >
                Withdraw Tokens
              </button>
              <button
                className="withdraw-matic"
                onClick={async () => {
                  await contract.withdrawMatic();
                  alert("Matic Witdrawn");
                }}
              >
                Widhtraw Matic
              </button>
              <div className="whitelist-input">
                <button
                  onClick={() => {
                    stopPreIeo();
                  }}
                  id="pre_ieo"
                >
                  Stop Pre-IEO
                </button>
              </div>
              <ConnectButton accountStatus="address" />
            </div>
          ) : (
            <ConnectButton accountStatus="address" />
          )}
        </div>
      </nav>
    </>
  );
};
